import { MaterialType } from "../../../../types/materials";
import { HeaderMenuItemTabBaseColorScheme, HeaderMenuItemTabColorScheme } from "./types";

export const tabColorScheme: Record<HeaderMenuItemTabColorScheme, string> = {
  [HeaderMenuItemTabBaseColorScheme.NeutralPrimaryTitle]: "bg-primary text-light",
  [MaterialType.Wood]: "bg-wood text-dark",
  [MaterialType.Stone]: "bg-stone text-dark",
  [MaterialType.Glass]: "bg-glass text-dark",
  [MaterialType.Materia]: "bg-materia text-dark",
  [MaterialType.Metal]: "bg-metal text-dark",
};

export const tabPanelColorScheme: Record<HeaderMenuItemTabColorScheme, string> = {
  [HeaderMenuItemTabBaseColorScheme.NeutralPrimaryTitle]:
    "bg-neutral text-dark [&_h3]:text-primary",
  [MaterialType.Wood]: "bg-wood text-dark",
  [MaterialType.Stone]: "bg-stone text-dark",
  [MaterialType.Glass]: "bg-glass text-dark",
  [MaterialType.Materia]: "bg-materia text-dark",
  [MaterialType.Metal]: "bg-metal text-dark",
};

export const linksSectionColorScheme: Record<
  HeaderMenuItemTabColorScheme,
  { title: string; link: string }
> = {
  [HeaderMenuItemTabBaseColorScheme.NeutralPrimaryTitle]: {
    title: "text-primary text-xl font-bold",
    link: "font-bold",
  },
  [MaterialType.Wood]: { title: "text-dark text-xl font-bold", link: "text-dark" },
  [MaterialType.Stone]: { title: "text-dark text-xl font-bold", link: "text-dark" },
  [MaterialType.Glass]: { title: "text-dark text-xl font-bold", link: "text-dark" },
  [MaterialType.Materia]: { title: "text-dark text-xl font-bold", link: "text-dark" },
  [MaterialType.Metal]: { title: "text-dark text-xl font-bold", link: "text-dark" },
};
